export const CASTOR_FIELD_TYPE_KEYWORD = 'KEYWORD',
  CASTOR_FIELD_TYPE_TEXT = 'TEXT',
  CASTOR_FIELD_TYPE_STRING = 'STRING',
  CASTOR_FIELD_TYPE_DATE = 'DATE';
